import React from "react";
import VideoModal from "../VideoModal/VideoModal";

const productDemos = [
  {
    title: "RentDirect — Smart Bookings",
    videoUrl: "https://player.vimeo.com/video/1074759397?h=5ec916ed69&autoplay=1&muted=1",
    img: '/img/ExploreDemo/rent_direct.svg',
    des: 'End to end booking with embedded rental workflows, tools & guest insurance validation.',
  },

  {
    title: "RentDirect — Smart Bookings + Ins",
    videoUrl: "https://player.vimeo.com/video/1074761289?h=53a38ba633&autoplay=1&muted=1",
    img: '/img/ExploreDemo/rent_direct.svg',
    des: 'End to end booking with embedded insurance and rental workflows & tools; featuring guest personal auto insurance protection.',
  },

  {
    title: "Gig Rentals — Book Vehicle + Insurance ",
    videoUrl: "https://player.vimeo.com/video/1074764835?h=ba4bd753f9&autoplay=1&muted=1",
    img: '/img/ExploreDemo/gig_rentals.svg',
    des: 'Gig and delivery drivers can seamlessly book your vehicle and purchase the compliant insurance they need.',
  },

  {
    title: "RentAI — Add a Vehicle",
    videoUrl: "https://player.vimeo.com/video/1075779497?h=5f637bd2cb&autoplay=1&muted=1",
    img: '/img/ExploreDemo/add_vehicle.svg',
    des: 'Add vehicles in seconds. No manual entry, just effortless setup- powered by Rentii, your AI rental task agent.',
  },

  {
    title: "RentSuccess - Guest Violations",
    videoUrl: "https://player.vimeo.com/video/1075534937?h=a4cf4e85a0&autoplay=1&muted=1",
    img: '/img/ExploreDemo/rent_success.svg',
    des: "Swiftly document and act on guest rule breaches—preserve standards, protect your rental, and keep operations smooth through rentid's Resolution Center.",
  },
  {
    title: "RentSuccess - Insurance Claim",
    videoUrl: "https://player.vimeo.com/video/1075536580?h=2b34488776&autoplay=1&muted=1",
    img: '/img/ExploreDemo/rent_success.svg',
    des: "File insurance claims in a few clicks with rentid's Resolution Center. Transparent, traceable, and tailored to keep your business moving forward.",
  },
  {
    title: "RentSuccess — Issue Refund",
    videoUrl: "https://player.vimeo.com/video/1075537477?h=998d1c0f6a&autoplay=1&muted=1",
    img: '/img/ExploreDemo/rent_success.svg',
    des: "Handle refunds with clarity and control through rentid's Resolution Center. Empower your team to resolve disputes confidently and consistently.",
  },
  {
    title: "RentSuccess — Report Guest",
    videoUrl: "https://player.vimeo.com/video/1075537985?h=6270d8d6ad&autoplay=1&muted=1",
    img: '/img/ExploreDemo/rent_success.svg',
    des: "Elevate trust and safety with rentid's Resolution Center. Easily report guest issues and contribute to a more secure rental community.",
  },
  {
    title: "Rentid — Guest App",
    videoUrl: "https://player.vimeo.com/video/1074762705?h=6f2c268a6a&autoplay=1&muted=1",
    img: '/img/ExploreDemo/rent_direct.svg',
    des: 'A fully self-serve rental journey — streamlined from start to finish.',
  },

  {
    title: "Car Rental Marketplace",
    videoUrl: undefined,
    img: '/img/ExploreDemo/marketplace.png',
    des: 'Join the only commission-less rental marketplace. Full control, better earnings. Launching mid 2025.',
    buttonText:'Launching Soon'

  },


];

const Productdemo = () => {

  return (
    <div className="row">

      {productDemos.map((product, index) => (
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 demo-pro-box" style={{ cursor: 'pointer' }} key={index}>
                  <VideoModal
                    key={index}
                    buttonText={product.buttonText}
                    videoUrl={product.videoUrl}
                    title={product.title}
                    image={product.img}
                    description={product.des}
                
                  />
                </div>
      ))}
      </div>
  );
};

export default Productdemo;
